import React from 'react'
import PropTypes from 'prop-types'

import './CollectionPoint.scss'

const CollectionPoint = ({ location }) => {
  return location
    ? (
      <div className='collection-point opening-hours opening-hours-icon'>
        <span className='collection-point__icon' aria-hidden />
        <h2 className='collection-point__title oh-title'>Collection point</h2>
        <span className='collection-point__location'>{location}</span>
      </div>
    )
    : null
}

CollectionPoint.defaultProps = {
  location: null
}

CollectionPoint.propTypes = {
  location: PropTypes.string
}

export default CollectionPoint



// WEBPACK FOOTER //
// ./src/components/CollectionPoint/CollectionPoint.jsx